import { Button } from '@ps/sports-ui-component-library';
import { AddNoOutline } from '@ps/sports-ui-component-library/icons/AddNoOutline';
import { useTrackers } from '@ps/web-shared-analytics';
import { Translation } from '@ps/web-shared-components';
import { type MyBet } from '@ps/web-sports-api-types';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import type { Dispatch } from '@swf/core/store';

import { getFutureOrInPlayLeg } from '../../../../../../utils/getFutureOrInPlayLeg';
import { getValidSelections } from '../../../../../../utils/getValidSelections';

import { TXTWCL_Add_To_Bet_Slip_1 } from './AddSelections.messages.json';
import styles from './AddSelections.scss';

interface Props {
  bet: MyBet;
}
const AddSelections: React.FC<Props> = (props) => {
  const { bet } = props;
  const dispatch = useDispatch<Dispatch>();
  const { buttonPressed } = useTrackers();
  const renderLabel = getFutureOrInPlayLeg(bet);
  const onClick = useCallback(() => {
    const validSelections = getValidSelections(bet);
    if (validSelections.length) {
      buttonPressed({ buttonName: 'Add To Bet Slip' });
      dispatch.betSlip.selectionsAdded(validSelections);
    }
  }, [dispatch, buttonPressed, bet]);
  if (!renderLabel) return null;
  return (
    <div className={styles.betSlipContainer}>
      <Button
        variant="tertiary"
        iconPosition="right"
        icon={AddNoOutline}
        size="small"
        onClick={onClick}
      >
        <Translation {...TXTWCL_Add_To_Bet_Slip_1} />
      </Button>
    </div>
  );
};

export default AddSelections;
